
export const STRIPE_KEY="pk_live_ItgVppr7jK9014Wpu4edxM0R00zKFGjx06"